<template>
  <div id="topbar">
    <div>
       <div id="logo"><img id="logo-img" src="@/assets/images/logo2.png" alt="logo" width="250"></div>
    </div>
    <currency-select id="currency"></currency-select>
  </div>
</template>

<style lang="scss" scoped>
#topbar {
  // background: linear-gradient($green2, $green1);
  background-color:rgba(0, 0, 0, 0.137);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0px 30px 0px;
  margin-bottom: 20px;
   @include respond(phone-only) {
     flex-direction:column;
  }
}

#logo {

  // border-radius: 20px;
  padding: 20px 0px 20px 0px;
  font-size: 30px;
  font-weight: bold;
  // @include respond(desktop-sm) {
  //   margin:0px 0px 20px 0px;
  // }
  // @include respond(phone-only) {
  //   font-size: 20px;
  // }
}

#logo-img {
  margin:5px 0px 0px 0px;
}

#highlight {
  color: $green1;
  font-size:16px;
  font-style:italic;
   @include respond(phone-only) {
    font-size: 14px;
  }
}


</style>

<script>
import CurrencySelect from "@/components/Shared/CurrencySelect";
export default {
  components: {
    CurrencySelect,
  },
};
</script>